export default __webpack_public_path__ + "static/media/Google-Play.346101f0.png";